<template lang="pug">
  div.changePwd
    van-form(@submit="onSubmit")
        van-field(class="changepwd_form", type="password", v-model="oldpwd", :placeholder="$t('inputOriginalPwd')", :rules="[{required: true, message: this.$t('inputOriginalPwd')}]")
        van-field(class="changepwd_form", type="password", v-model="newpwd", :placeholder="$t('inputNewPwd')", :rules="[{required: true, message: this.$t('inputNewPwd')},{validator: pwdValidator, message: pwdmsg}]", @input="inputMsg")
        van-field(class="changepwd_form", type="password", v-model="repeatpwd", :placeholder="$t('inputNewPwdAgain')", :rules="[{required: true, message: this.$t('inputNewPwdAgain')}, {validator: repeatValidator, message: repeatmsg}]", @input="inputRepeatMsg")
        van-button(class="changepwd_btn", native-type="submit", type="danger", block, round, :disabled='isDisabled') {{$t('sure')}}
</template>

<script>
// @ is an alias to /src
// import HelloWorld from '@/components/HelloWorld.vue'
import {mapActions, mapGetters} from 'vuex';
import Qs from 'qs';
import { Toast } from 'vant';

export default {
  name: 'Faq',
  data(){
    return {
        oldpwd: '',
        newpwd: '',
        repeatpwd: '',
        isDisabled: false
    }
  },
  created(){
      
  },
  methods:{
    ...mapActions('user', ['changePwd']),
    pwdValidator(val){
      if(val.length > 18 || val.length < 6){
        this.pwdmsg = this.$t('pwdPatternErr')
        return false
      }
    },
    inputMsg(val){
      const str = '0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ@._#$;?&*,!'.split('')
      const pwd = this.newpwd.split('').map(v => {
        if(!str.includes(v)){
          this.newpwd = this.newpwd.replace(v, '')
        }
      })
    },
    inputRepeatMsg(val){
      const str = '0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ@._#$;?&*,!'.split('')
      const pwd = this.repeatpwd.split('').map(v => {
        if(!str.includes(v)){
          this.repeatpwd = this.repeatpwd.replace(v, '')
        }
      })
    },
    onSubmit(){
        if(this.oldpwd === this.newpwd){
            Toast.fail(this.$t('pwdTheSame'));
            return false
        }
        if(this.oldpwd && (this.newpwd === this.repeatpwd)){
          if(!this.isDisabled){
            this.changePwd(Qs.stringify({
                uid: this.uid,
                deviceId: this.deviceId,
                accessToken: this.token,
                oldPassword: this.$md5(this.oldpwd),
                newPassword: this.$md5(this.repeatpwd)
            }))
            this.isDisabled = true
          }
        }
    },
    repeatValidator(val){
        if(val !== this.newpwd){
            this.repeatmsg = this.$t('pwdDontmatch');
            return false
        }
        return true
    }
  },
  computed:{
    ...mapGetters(['uid', 'deviceId', 'token']),
    ...mapGetters('user', ['errmsg', 'changing', 'changeState']),
    pwdmsg: $vm => {
      return $vm.$t('pwdPatternErr')
    },
    repeatmsg: $vm => {
      return $vm.$t('pwdDontmatch')
    },
  },
  mounted(){
    this.$watch('changing', val => {
      if(val === 'changed'){
        if(this.changeState === 'success'){
          Toast({
            message: this.$t('changeSuccess'),
            type: 'success',
            onClose: () => {
              typeof(ntAndroidWeb) !== 'undefined' && ntAndroidWeb.doPlatLogout({}) || (window.webkit && window.webkit.messageHandlers && window.webkit.messageHandlers.doPlatLogout.postMessage(null))
            }
          })
        }
        this.isDisabled = false
      } else {
        this.isDisabled = false
      }
    })
  }
}
</script>
<style lang="scss" scoped>
.changePwd{
    margin: 20px;
    .changepwd_form{
      margin-top: 20px;
      border-radius: 5px;
      box-shadow: 0px 0px 5px 2px #ebebeb;
    }
    .changepwd_btn{
        margin-top: 20px;
        width: 90%;
        left: 5%;
        padding: 15px;
    }
}
</style>